"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.edit.title': '编辑机器人测试',
};
